import { create } from "apisauce";
import store from '../store'
const ipRegistry = create({
	baseURL: "https://api.ipstack.com",
});
const ipStackClient = create({
	baseURL: process.env.REACT_APP_IPSTACK_API
})
const adminApi = create({
	baseURL: process.env.REACT_APP_API_END_POINT + "/api/",
});
const cardsActivityadminApi = create({
	baseURL: process.env.REACT_APP_API_END_POINT + "/api/",
});
const devlopConfigAPi = create({
	baseURL: process.env.REACT_APP_API_END_POINT + "/api/",
});
const gatewaysApi = create({
	baseURL: process.env.REACT_APP_GATEWAYS + "api/",
});
const identityApi = create({
	baseURL: process.env.REACT_APP_IDENTITY + "api/",
});
const loginApi = create({
	baseURL: process.env.REACT_APP_AUTHORITY + "/api/",
});
const cardsServiceApi = create({
	baseURL: process.env.REACT_APP_API_END_POINT + "/api/v1/",
});
adminApi.axiosInstance.interceptors.request.use((config) => {
	const access_token = store.getState().oidc?.profile?.access_token;
	config.headers.Authorization = `Bearer ${access_token}`;
	config.headers['Content-Type'] = 'application/type';
	return config;
})
const adminabpApi = create({
	baseURL: process.env.REACT_APP_API_END_POINT + "/api/abp/",
});
adminabpApi.axiosInstance.interceptors.request.use((config) => {
	const access_token = store.getState().oidc?.profile?.access_token;
	config.headers.Authorization = `Bearer ${access_token}`;
	config.headers['Content-Type'] = 'application/type';
	return config;
})
cardsActivityadminApi.axiosInstance.interceptors.request.use((config) => {
	const access_token = store.getState().oidc?.profile?.access_token;
	config.headers.Authorization = `Bearer ${access_token}`;
	config.headers['Content-Type'] = 'application/type';
	return config;
})
devlopConfigAPi.axiosInstance.interceptors.request.use((config) => {
	const access_token = store.getState().oidc?.profile?.access_token;
	config.headers.Authorization = `Bearer ${access_token}`;
	config.headers['Content-Type'] = 'application/json';
	return config;
})
gatewaysApi.axiosInstance.interceptors.request.use((config) => {
	const access_token = store.getState().oidc?.profile?.access_token;
	config.headers.Authorization = `Bearer ${access_token}`;
	config.headers['Content-Type'] = 'application/json';
	return config;
})
loginApi.axiosInstance.interceptors.request.use((config) => {
	const access_token = store.getState().oidc?.profile?.access_token;
	config.headers.Authorization = `Bearer ${access_token}`;
	config.headers['Content-Type'] = 'application/json';
	return config;
})
identityApi.axiosInstance.interceptors.request.use((config) => {
	const access_token = store.getState().oidc?.profile?.access_token;
	config.headers.Authorization = `Bearer ${access_token}`;
	config.headers['Content-Type'] = 'application/json';
	return config;
})
cardsServiceApi.axiosInstance.interceptors.request.use((config) => {
	const access_token = store.getState().oidc?.profile?.access_token;
	config.headers.Authorization = `Bearer ${access_token}`;
	config.headers['Content-Type'] = 'application/json';
	return config;
})
export {
	ipRegistry,
	adminApi,
	ipStackClient, adminabpApi, cardsActivityadminApi, devlopConfigAPi, gatewaysApi, loginApi,identityApi,
	cardsServiceApi
};
